import { Injectable } from '@angular/core'; 
@Injectable({
    providedIn: 'root',
  })
  export class SessionStorageService {
     
    getItem(key: string) {
      try {
        const result =  sessionStorage.getItem(key);
        return result;
      } catch (error) {
        console.log(error);
        return null;
      }
    }
  
    setItem(key: string, value: any, ttl: number) {
      const now = new Date();
      const item = { value, expiry: now.getTime() + ttl };
      sessionStorage.setItem(key, JSON.stringify(item));
    }
  
    removeItem(key: string) {
      sessionStorage.removeItem(key);
    }
  
    clearEntireSession() {
      sessionStorage.clear();
    }
  }